export const getSearchParamsObj = (search, filters) => {
  const obj = {};
  const params = new URLSearchParams(search);

  if (params.toString() !== '') {
    for (const [key, val] of params.entries()) {
      const hasDeserialize = typeof filters[key].deserialize === 'function';
      obj[key] = hasDeserialize ? filters[key].deserialize(val) : val;
    }
  }

  return obj;
};
